import { useEffect } from "react";
import { isMobile } from "../../utils/func";
import { Section1 } from "./component/Section1";
import { Section2 } from "./component/Section2";
import { Section3 } from "./component/Section3";
import { Section4 } from "./component/Section4";
import { Section5 } from "./component/Section5";
import { Section6 } from "./component/Section6";
import { setDescription } from "../../seo/seo";
import Banner from "../../component/Banner";

const ServiceIntro = () => {
  useEffect(() => {
    document.title = "품 : Poom | 서비스 소개";
    setDescription(
      "분산된 정산 프로세스를 하나로 연결합니다. 핀테크 전문 기업 위지온의 기술력으로 비즈니스 운영의 유동성과 신뢰도를 높여드립니다.",
    );
  }, []);
  return (
    <div className="w-full flex flex-col">
      {/* 상단 배너 */}
      <section className="w-full flex flex-col pt-6 md:pt-3 justify-center items-center px-6">
        <Banner
          pcImage="/assets/images/serviceIntro/bg.webp"
          mobileImage="/assets/images/serviceIntro/bg_mobile.webp"
          priority // 첫 화면 아니면 제거
        >
          <span className="text-black font-bold text-[20px] md:text-display3 text-center">
            <span className="md:hidden">
              복잡하고 <br /> 품 드는 정산, <br /> 이제 쉽게 해결하세요.
            </span>
            <span className="hidden md:inline">
              복잡하고 품 드는 정산, <br /> 이제 쉽게 해결하세요.
            </span>
          </span>
        </Banner>
      </section>

      {/* 본문 영역 */}
      <section>
        <div className="pt-[120px] md:py-[160px] flex flex-col gap-[120px] md:gap-[160px]">
          <Section1 />
          <Section2 />
          <div className="flex flex-col gap-[60px] md:gap-[160px]">
            <Section3 />
            <Section4 />
          </div>
          <Section5 />
        </div>
        <Section6 />
      </section>
    </div>
  );
};

export default ServiceIntro;
